module.exports = __webpack_public_path__ + "static_portal/img/sort-down.890b423f.svg";